import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { showSuccessFlag } from '@helpcenter/flags';
import {
	hideFeedbackCollector,
	updateAdditionalFieldsInFeedbackCollector,
} from 'state/actions/feedback-collector';
import {
	getShouldOpenFeedbackWidget,
	getShowTypeField,
	getAdditionalFields,
	getCustomComponent,
} from 'state/selectors/feedback-collector';
import { getDisplayName, getUserState } from 'state/selectors/user';
import FeedbackCollector from './feedback-collector';

const selector = createSelector(
	getUserState,
	getDisplayName,
	getShouldOpenFeedbackWidget,
	getShowTypeField,
	getAdditionalFields,
	getCustomComponent,
	(
		userState,
		name,
		shouldOpenFeedbackWidget,
		showTypeField,
		additionalFields,
		CustomComponent,
	) => ({
		name,
		showTypeField,
		additionalFields,
		CustomComponent,
		isOpen: shouldOpenFeedbackWidget,
		accountId: userState.accountId,
	}),
);

const mapDispatchToProps = {
	hideFeedbackCollector,
	updateAdditionalFieldsInFeedbackCollector,
	showSuccessFlag,
};

export default connect(selector, mapDispatchToProps)(FeedbackCollector);
